window.Vue = require('vue');

export class FilterService {

    constructor() {
        this._filters = [];
        this._query = '{}';
    }

    getFilter(filterId) {

        let result = null;
        let filters = this._filters.filter(function(filter) { return filter.Id === filterId});
        if (filters.length === 1) {
            result = filters[0];
        }

        return result;
    }

    setFilter(filter, emitChanged = true) {

        if(!this.getFilter(filter.Id)) {
            this._filters.push(filter);

            bus.$emit('filter:added', filter);

            if(emitChanged) {
                this.emitChanged();
            }
        }

    }

    emitChanged() {
        bus.$emit('filters:changed', this._filters);
    }

    removeFilter(filterId, emitChanged = true) {
        if(this.getFilter(filterId)) {
            this._filters = this._filters.filter(function(filter) { return filter.Id !== filterId})
            bus.$emit('filter:deleted', filterId);
            if(emitChanged) {
                this.emitChanged();
            }
        }
    }

    filters() {
        return Object.assign({}, this._filters);
    }

    filtersCount() {
        return Object.keys(this._filters).length;
    }

    getQuery() {
        return this._query;
    }

    setQuery(query) {
        this._query = query;
    }
}
